import { render, staticRenderFns } from "./imagePicker.vue?vue&type=template&id=0b33df40&scoped=true"
import script from "./imagePicker.vue?vue&type=script&lang=js"
export * from "./imagePicker.vue?vue&type=script&lang=js"
import style0 from "./imagePicker.vue?vue&type=style&index=0&id=0b33df40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b33df40",
  null
  
)

export default component.exports